export default __webpack_public_path__ + "static/media/chartView.52d2478b.svg";